// removed by extract-text-webpack-plugin
module.exports = {"grid-figure":"_17lXaAygKZZHzsstAzNlFl","header":"_39XIyUDzzVP21X0QyFU0Bc","settings-view":"_38brrlU1Kqxwz-nMS0oRjb","setings-bottom":"_2_2_-qlTbolk0-zOy9hU9V"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/Settings.styl
// module id = 486
// module chunks = 0